export const BA = {
    translations: {
        notifications: 'Иҫкәрмәләр',
        markAllAsRead: 'Барыһын да уҡылғанса тамғалағыҙ',
        poweredBy: 'Эшләй',
        settings: 'Көйләүҙәре',
        noNewNotification: 'Монда әле яңа нәрсә юк',
    },
    lang: 'ba',
};
//# sourceMappingURL=ba.js.map